import React, { useEffect, useState } from "react";
import { useAuth } from "context/AuthContext";
import { useNavigate } from "react-router-dom";
import { ReactComponent as MenuSgv } from "assets/icons/menu.svg";
import { useUserInfo } from "hooks/useUserInfo";
import Aside from "./Aside";
import "styles/navbar.css";

import { ReactComponent as SvgLogo } from "assets/icons/elite-vacances/eliteVacances.svg";
import { ReactComponent as SvgFacebook } from "assets/icons/facebook.svg";
import { ReactComponent as SvgInstagram } from "assets/icons/instagram.svg";
import { ReactComponent as SvgTiktok } from "assets/icons/tiktok.svg";
import { ReactComponent as SvgPhone } from "assets/icons/phone.svg";

const Navbar = () => {
  const navigate = useNavigate();
  const { data: user, isError } = useUserInfo();
  const { logout } = useAuth();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeSesion = () => {
    logout();
    navigate("/");
  };

  useEffect(() => {
    if (isError) {
      logout();
      navigate("/");
    }
  }, [isError, navigate, logout]);

  return (
    <header className="navbar">
      <div className="navbarRow navbarHeader">
        <div className="navbarLogo">
          <SvgLogo />
        </div>

        <div className="navbarContact">
          <a
            href="https://www.facebook.com/elitevacances"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="navbarSocialLink"
          >
            <SvgFacebook />
          </a>

          <a
            href="https://www.instagram.com/elitevacances/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="navbarSocialLink"
          >
            <SvgInstagram />
          </a>

          <a
            href="https://www.tiktok.com/@elitevacances"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
            className="navbarSocialLink"
          >
            <SvgTiktok />
          </a>

          <a
            href="tel:+576017945996"
            aria-label="Llamar a Elite Vacances"
            className="navbarSocialLink"
          >
            <SvgPhone />
          </a>

          <a href="tel:+576017945996" className="navbarPhone">
            +57 (1) 7945996
          </a>
        </div>
      </div>
      <div className="navbarRow navbarNavigation">
        <h1 className="navbarWelcome">Bienvenido</h1>

        <div className="navbarMenu">
          <button
            type="button"
            className="navbarMenuButton"
            onClick={toggleMenu}
            aria-expanded={isMenuOpen}
            aria-controls="navbar-menu"
          >
            <MenuSgv className="navbarMenuIcon" />

            <span>Menú</span>
          </button>

          {isMenuOpen && (
            <div id="navbar-menu" className="navbarMenuDropdown">
              <Aside />

              <button
                type="button"
                className="navbarLogout"
                onClick={closeSesion}
              >
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="navbarUserInfo">
        <div className="navbarUserItem navbarUserName">
          <span>{user?.nombres}</span>
        </div>

        <div className="navbarUserItem">
          <span className="navbarUserLabel">Email</span>

          <span className="navbarUserValue">{user?.correo}</span>
        </div>

        <div className="navbarUserItem">
          <span className="navbarUserLabel">Área</span>

          <span className="navbarUserValue">{user?.area}</span>
        </div>

        <div className="navbarUserItem">
          <span className="navbarUserLabel">Cargo</span>

          <span className="navbarUserValue">{user?.cargo}</span>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
